import { render, staticRenderFns } from "./complicacionesIdentificadasShow.vue?vue&type=template&id=60b4fc33&scoped=true"
import script from "./complicacionesIdentificadasShow.vue?vue&type=script&lang=js"
export * from "./complicacionesIdentificadasShow.vue?vue&type=script&lang=js"
import style0 from "./complicacionesIdentificadasShow.vue?vue&type=style&index=0&id=60b4fc33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b4fc33",
  null
  
)

export default component.exports